import * as React from "react";
import type { SVGProps } from "react";
const SvgSignal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M11.944 12H12M9.674 7.8A4.8 4.8 0 0 0 7.2 12c0 1.807.999 3.381 2.474 4.2m4.652-8.4A4.8 4.8 0 0 1 16.8 12a4.8 4.8 0 0 1-2.474 4.2M7.2 20.316A9.6 9.6 0 0 1 2.4 12a9.6 9.6 0 0 1 4.8-8.316m9.6 16.632A9.6 9.6 0 0 0 21.6 12a9.6 9.6 0 0 0-4.8-8.316"
    />
  </svg>
);
export default SvgSignal;
